// extracted by mini-css-extract-plugin
module.exports = {"distanceContainer":"StationDistance__distanceContainer___3JFP6"};